import { SHARED } from "@apps/patient-core/src/app/shared";
import { Component } from "@angular/core";

@Component({
  selector: "dentr-login-terms-ca",
  templateUrl: "./login-terms-ca.component.html",
  standalone: true,
  imports: [SHARED],
})
export class LoginTermsCAComponent {}
